<template>
    <div class="w">
        <div class="datails_nav">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item :to="{ path: '/' }">
                <i class="el-icon-s-home" />首页
                </el-breadcrumb-item>
                <el-breadcrumb-item :to="{ path: '/talent' }">
                高层次人才库
                </el-breadcrumb-item>
                <el-breadcrumb-item>详情</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="conent">
            <div class="conent-head">
                <div class="conent-head-one">
                    <el-row>
                        <el-col :span="5">
                            <div class="chimg">
                                <img v-if="taleitem.Sex==0" src="../../../assets/library/蒙版组 125.png" alt="">
                                <img v-else  src="../../../assets/library/蒙版组 125@2x.png" alt="">
                            </div></el-col>
                        <el-col :span="14">
                            <div class="chtext">
                        <div class="chtext-name">{{taleitem.FullName}}</div>
                        <div class="chtext-guno">
                            <img src="../../../assets/library/公司名称.png" alt="">
                            <span>工作单位：{{taleitem.UnitName}}</span>
                        </div>
                        <div class="chtext-flex">
                            <div>
                                <span>性别：{{taleitem.Sex==0? '男':'女'}}</span>
                                <span>职位称职：{{taleitem.TechnicalPosition}}</span>
                                <span>从事专业或方向：{{taleitem.Direction}}</span>
                            </div>
                            <div>
                                <span>最高学历：{{taleitem.Education}}</span>
                                <span>联系电话：{{taleitem.Telphone}}</span>
                                <span>主要研发类别：{{taleitem.Categories}}</span>
                            </div>
                            <div>
                                <span>最高学位：{{taleitem.Degree}}</span>
                            </div>
                        </div>
                    </div>
                        </el-col>
                        <el-col :span="4">
                            <div class="chguan">
                                <span @click="concern" v-if="taleitem.Remarks=='n' || taleitem.Remarks==''">+ 关注</span>
                                <span @click="concern" v-else>已关注</span>
                            </div>
                        </el-col>
                    </el-row>
                </div>
            </div>
            <div class="conent-but">
                <div class="cbut-img">
                    <img src="../../../assets/library/组 4238.png" alt="">
                    <span>简介</span>
                </div>
                <div class="cbut-notext" v-if="taleitem.OtherAchievements==''">
                    暂无简介
                </div>
                <div v-else class="cbut-text">
                    {{taleitem.OtherAchievements}}
                </div>
            </div>
            <div class="xunent">
                <div class="x-tope">
                    <div class="xt-text">
                        <img src="../../../assets/library/蒙版组 124(1).png" alt="">
                        <span>相关需求</span>
                    </div>
                    <div class="divflex">
                            <div class="crttwo" v-for="item in xuqiuL" :key="item.id" @click="xuqiuid(item.id)">
                                <div class="crttwoimg"><img :src="item.PictureUrl" alt=""></div>
                                <div class="crttwotext">
                                    <b class="one">{{item.Title}}</b>
                                    <div>预算资金：<span class="tit">{{item.InvestmentAmount}} <span v-if="item.InvestmentAmount!==null && item.InvestmentAmount!==''">万元</span> </span></div>
                                    <div>技术领域: <span class="tile">{{item.TechFieldEnum}}</span> </div>
                                </div>
                            </div>
                    </div>
                </div>

                <div class="x-tope">
                    <div class="xt-text">
                        <img src="../../../assets/library/蒙版组 124.png" alt="">
                        <span>相关成果</span>
                    </div>
                    <div class="divflex">
                             <div class="crttwo" v-for="item in getchenglist" :key="item.id" @click="crttid(item.id)">
                        <div class="crttwoimg"><img :src="item.PictureUrl" alt=""></div>
                        <div class="crttwotext">
                            <b class="one">{{item.Title}}</b>
                            <div>合作方式：<span class="ittext">{{item.ModeOfCooperation}}<span v-if="item.ModeOfCooperation=='' || item.ModeOfCooperation==null">无</span></span></div>
                            <div>项目阶段：<span class="ittext">{{item.ProjectPhaseName}}</span></div>
                        </div>
                    </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { getAction, postAction } from "@/api/api";
import qs from "qs";
import {library,cloudSelect } from "@/api/url";
export default {
   data(){
       return{
         talentid:0,
         taleitem:{},
         xuqiuL:[],//相关需求,
         getchenglist:[],//相关成果，
         centerDialogVisible:false,//弹框
         Remarks:{
         }//收藏
       }
   },
   created(){
       
     this.talentid =this.$route.query.list;
     this.linfoList()
     this.getxiang()
     this.getcheng()
   },
   mounted(){
       this.ToNewsInfo()
       this.$bus.$on("LoginSuccess", (e) => {
      if (e) {
        this.linfoList();
      }
    });
   },
   methods:{
       ToNewsInfo() {
      //判断是否是PC设备，true是，false不是
         //判断是否是PC设备，true是，false不是
      let userAgentInfo = navigator.userAgent
      console.log(navigator.userAgent)
      let Agents = ['Android', 'iPhone', 'SymbianOS', 'Windows Phone', 'iPod']
      let flag = true
      for (let j = 0; j < Agents.length; j++) {
        console.log(userAgentInfo.indexOf(Agents[j]))
        if (userAgentInfo.indexOf(Agents[j])>0) {
          flag = false
          break
        }
      }
      console.log(window.screen.width)
      if (window.screen.width >= 768) {
        flag = true
      }
      if (flag) {
        this.$router.push({
          path: '/talentPoolinfo',
          query: { list: this.talentid },
        })
      } else {
        window.location.href=this.Urls+'/Mobile/index.html#/TalentPoolDetail?id=' +
            this.talentid
        
      }
    },
       linfoList(){
           let data={
           action:"Get_PersonnelregInfo",
           id:this.talentid
       }
           postAction(library,qs.stringify(data)).then(res=>{
               this.taleitem=res
           })
       },
       //相关需求
       getxiang(){
           let data={
               action:"GetCorrelationDemandList",
               id:this.talentid,
               type:1
           }
           getAction(cloudSelect,data).then(res=>{
               this.xuqiuL=res.list
           })
       },
       //相关成果
       getcheng(){
           let data={
               action:"GetCorrelationAchievementsList",
               id:this.talentid,
               type:1
           }
           getAction(cloudSelect,data).then(res=>{
               this.getchenglist=res.list
           })
       },
       //相关成果跳转
    crttid(id){
        let routeData = this.$router.resolve({
        path: "/fruitDetail",
        query: {
          id,
        },
      });
      window.open(routeData.href, "_blank");

    },
    //需求
    xuqiuid(id){
        let routeData = this.$router.resolve({
        path: "/demandDetail",
        query: {
          id,
        },
      });
      window.open(routeData.href, "_blank");

    },
    //登陆成功
    LoginSuccess() {
      let data = {
        action: "Get_UserInfo",
      };
      postAction(library, qs.stringify(data)).then((res) => {
        this.RealName = res.RealName;
        window.localStorage.setItem("RealName", res.RealName);
      });
      this.$router.go(0);
    },
    //关注
    concern(id){
      let data= window.localStorage.getItem("RealName")
      if(data==""){
        this.$confirm("当前未登录,是否跳转到登录页?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            this.$bus.$emit("dialogVisible",true);
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消",
            });
          });
      }else{

          let b=window.localStorage.getItem("RealID")
           let data={
           action:"Collection_Items",
           ProjectID:this.talentid,
           UserID:b,
           type:3
             }
           postAction(library,qs.stringify(data)).then(res=>{
               if(res.status=="n"){
                   this.$message.success("取消关注")
               }else{
                   this.$message.success("已经关注")
               }
               this.linfoList()
           })
      }
      
    },
   }

}
</script>

<style lang="scss" scoped>
 .w{
     width: 87.5rem;
     height: auto;
     margin: 0 auto;
 }
 .datails_nav {
  text-align: left;
  height: 5.125rem;
  line-height: 5.125rem;
  font-size: 0.875rem;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ccc;
  display: flex;
  align-items: center;
}

.datails_nav .layui-breadcrumb a {
  color: #999 !important;
}
/deep/.is-link{
    z-index: 999;
    color:#606266
}
.conent{
    width: 100%;
    height: auto;
    box-shadow: 0 .1875rem 1rem rgba(0, 0, 0, 0.08);
}
.conent-head{
    padding:1.25rem 1.875rem 0;
}
.conent-head-one{
    overflow:hidden;
    text-align: left;
}
.chimg{
    width:13.125rem;
    height:13.125rem;
    float: left;
    text-align: left !important;
    overflow: hidden;
}
.chimg img{
    display: block;
    width:13.125rem;
    height:13.125rem;
}
.chtext{
    float: left;
    height: 100%;
    width: 100%;
}
.chguan{
    float:right;
    color: #fff;
    text-align: center;
    cursor: pointer;
}
.chguan span{
    display: inline-block;
    width:6.3125rem;
    height:2.1875rem;
    line-height:2.3rem;
    background: #2769DC;
}
.chtext-name{
    font-weight: 600;
    font-size: 1.625rem;
    font-family: Microsoft YaHei;
    color: #333;
    margin-bottom: 1.125rem;
}
.chtext-guno img{
    width:1.1875rem;
    height:1rem;
    vertical-align: bottom;
    margin-right: .3125rem;
}
.chtext-guno{
    display: inline-block;
    color:#666;
    font-size: 1rem;
}
.chtext-flex{
    display: flex;
    justify-content: space-between;
    width: 100%;
    margin-top:2.125rem;
    color:#666;
}
.chtext-flex div span{
    display: block;
    margin-bottom: .875rem;
}
.conent-but{
    margin-top:1.875rem;
    padding: 1.875rem;
    text-align: left !important;
}
.cbut-img{
    width:100%;
    border-bottom: .0625rem solid #E2E2E2 ;
    height:2.5rem;
    line-height: 2.5rem;
    overflow: hidden;
    margin-bottom:.9375rem;
}
.cbut-img img{
    width: 2rem;
    height: 2rem;
    vertical-align: top;
    margin-right: .625rem;
}
.cbut-img span{
    display: inline-block;
    font-weight: 700;
    font-size: 1.75rem;
}
.cbut-text{
    color:#4A4A4A ;
    width:100%;
    line-height: 1.875rem;
    font-family: Microsoft YaHei;
    font-size:1.125rem;
    min-height:1.875rem;
    overflow: hidden;
}
.cbut-notext{
    height: 5rem;
    line-height: 5rem;
    color: #999;
    background: #F5F5F5;
    text-align: center;

}
/*  */
.xunent{
    padding:1.875rem;
    text-align: left;
    padding-top: 0;
}
.x-tope{
    padding-bottom:.625rem;
}
.xt-text{
     width:100%;
    border-bottom: .0625rem solid #E2E2E2 ;
    height:2.5rem;
    line-height: 2.5rem;
    overflow: hidden;
    margin-bottom:.9375rem ;
}
.xt-text img{
    width: 2rem;
    height: 2rem;
    vertical-align: top;
    margin-right: .625rem;
}
.xt-text span{
     display: inline-block;
    font-weight: 700;
    font-size: 1.75rem;
}
.divflex{
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
}
.crttwo{
    width:26.9375rem;
    height: 22.9375rem;
    display: inline-block;
    margin-bottom: 1.25rem;
    box-shadow: 0rem .1875rem 1rem rgba(0, 0, 0, 0.08);
    cursor: pointer;
}
.crttwoimg{
    width:100%;
    height:14.5625rem;
    background: #333333;
}
.crttwoimg img{
    width: 100%;
    height: 100%;
}
.crttwotext{
    text-align: left;
    padding: .8125rem;
    line-height: 1.875rem;
}
.crttwotext .one{
    display: inline-block;
    width:100%;
    font-size: 1.1875rem;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
}
.crttwotext div{
    color:#E4E4E4;
}
.tit{
    color:#F15916;
    font-family: Microsoft YaHei;
}
.tile{
    color:#C9C9C9;
}
.ittext{
    color:#D0D0D0;
}
</style>